var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('a',{staticClass:"t-banner",attrs:{"href":_vm.banner.link,"target":"_blank"}},[_c('img',{staticClass:"t-banner__img",class:{'t-banner__img_mobile':_vm.mobileState},attrs:{"src":_vm.mobileState?_vm.banner.imgMobile:_vm.banner.img}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dc898b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue_components/Banner.vue
// module id = 239
// module chunks = 0